import React from 'react';
import { observer } from 'mobx-react';
import { FulfillmentOrderHistoryLogListTemplate } from 'themes/modules/order/pages';
import { FulfillmentOrderHistoryLogViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new FulfillmentOrderHistoryLogViewStore(rootStore), 'fulfillmentOrderHistoryLogViewStore')
@observer
class FulfillmentOrderHistoryLogList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <FulfillmentOrderHistoryLogListTemplate {...this.props} headerCell={[]} />;
	}
}

export default FulfillmentOrderHistoryLogList;
